import { getResource } from "../../../language/resources/getResource";

/**
 * From the resources, not hardcoded: the hint telling the user what to type is
 * localized, and a gate still expecting "delete" would be unreachable in that locale.
 */
export const bulkDeleteConfirmPhrase = (resources: Record<string, any>): string =>
  getResource(resources, "ACCESS_RULE_BULK_DELETE_CONFIRM_PHRASE");

/**
 * Case-insensitive, but deliberately not trimmed: whitespace, partial entries and
 * empty input do NOT confirm. A pasted value shouldn't satisfy a keystroke gate.
 */
export const isBulkDeleteConfirmed = (input: string, phrase: string): boolean =>
  input.toLowerCase() === phrase.toLowerCase();
